interface ArbitrationSVGProps {
  color?: string;
}

const ArbitrationSVG: React.FC<ArbitrationSVGProps> = ({
  color = "#4F46E5",
}) => {
  return (
    <svg
      viewBox="0 0 400 300"
      className="w-full h-full transform transition-transform duration-300 rounded-lg"
    >
      <defs>
        <linearGradient
          id="arbitration-gradient"
          x1="0%"
          y1="0%"
          x2="100%"
          y2="100%"
        >
          <stop offset="0%" stopColor={color} stopOpacity="0.1" />
          <stop offset="100%" stopColor={color} stopOpacity="0.05" />
        </linearGradient>
        <filter id="arbitration-glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur" />
          <feMerge>
            <feMergeNode in="coloredBlur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <style>
        {`
          @keyframes balance {
            0% { transform: rotate(0deg); }
            25% { transform: rotate(1deg); }
            75% { transform: rotate(-1deg); }
            100% { transform: rotate(0deg); }
          }
          @keyframes float {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-2px); }
            100% { transform: translateY(0px); }
          }
          @keyframes pulse-subtle {
            0% { transform: scale(1); opacity: 0.6; }
            50% { transform: scale(1.02); opacity: 0.7; }
            100% { transform: scale(1); opacity: 0.6; }
          }
          .balance { animation: balance 10s ease-in-out infinite; }
          .float { animation: float 10s ease-in-out infinite; }
          .pulse-subtle { animation: pulse-subtle 8s ease-in-out infinite; }
        `}
      </style>

      {/* Background */}
      <rect width="400" height="300" fill="url(#arbitration-gradient)" />

      <g className="float">
        {/* Central pillar */}
        <rect
          x="195"
          y="90"
          width="10"
          height="140"
          fill={color}
          opacity="0.2"
          className="transition-colors duration-500"
        />

        {/* Balance beam */}
        <g className="balance" style={{ transformOrigin: "200px 90px" }}>
          <rect
            x="120"
            y="85"
            width="160"
            height="10"
            fill={color}
            opacity="0.2"
            className="transition-colors duration-500"
          />

          {/* Left scale */}
          <g className="pulse-subtle">
            <line
              x1="120"
              y1="95"
              x2="120"
              y2="145"
              stroke={color}
              strokeWidth="2"
              opacity="0.15"
              className="transition-colors duration-500"
            />
            <circle
              cx="120"
              cy="145"
              r="30"
              fill={color}
              opacity="0.1"
              className="transition-colors duration-500"
            />
            <circle
              cx="120"
              cy="145"
              r="25"
              fill={color}
              opacity="0.15"
              className="transition-colors duration-500"
            />
          </g>

          {/* Right scale */}
          <g className="pulse-subtle" style={{ animationDelay: "0.5s" }}>
            <line
              x1="280"
              y1="95"
              x2="280"
              y2="145"
              stroke={color}
              strokeWidth="2"
              opacity="0.15"
              className="transition-colors duration-500"
            />
            <circle
              cx="280"
              cy="145"
              r="30"
              fill={color}
              opacity="0.1"
              className="transition-colors duration-500"
            />
            <circle
              cx="280"
              cy="145"
              r="25"
              fill={color}
              opacity="0.15"
              className="transition-colors duration-500"
            />
          </g>
        </g>

        {/* Base */}
        <path
          d="M160 230 L240 230 L230 250 L170 250 Z"
          fill={color}
          opacity="0.2"
          className="transition-colors duration-500"
        />
      </g>
    </svg>
  );
};

export default ArbitrationSVG;
